import React, { useState, useEffect } from 'react';
import { Button } from '@/components/ui/button';
import { removeBackground, loadImage } from '@/utils/backgroundRemoval';
import { Download, Loader2 } from 'lucide-react';

const LogoProcessor = () => {
  const [isProcessing, setIsProcessing] = useState(false);
  const [processedImageUrl, setProcessedImageUrl] = useState<string | null>(null);

  const processLogo = async () => {
    setIsProcessing(true);
    try {
      // Fetch the current logo
      const response = await fetch('/lovable-uploads/eef14428-6654-485e-9b58-0794433074cd.png');
      const blob = await response.blob();
      
      // Load the image
      const imageElement = await loadImage(blob);
      
      // Remove background
      const processedBlob = await removeBackground(imageElement);
      
      // Create URL for the processed image
      const url = URL.createObjectURL(processedBlob);
      setProcessedImageUrl(url);
      
      console.log('Background removal completed successfully');
    } catch (error) {
      console.error('Error processing logo:', error);
    } finally {
      setIsProcessing(false);
    }
  };

  const downloadProcessedImage = () => {
    if (processedImageUrl) {
      const link = document.createElement('a');
      link.href = processedImageUrl;
      link.download = 'carekonnect-logo-no-background.png';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }
  };

  return (
    <div className="max-w-md mx-auto p-6 space-y-4">
      <h2 className="text-xl font-semibold text-center">Logo Background Remover</h2>
      
      <div className="space-y-4">
        <div className="text-center">
          <p className="text-sm text-muted-foreground mb-4">
            This will remove the background from your current logo
          </p>
          <Button 
            onClick={processLogo} 
            disabled={isProcessing}
            className="w-full"
          >
            {isProcessing ? (
              <>
                <Loader2 className="w-4 h-4 mr-2 animate-spin" />
                Processing...
              </>
            ) : (
              'Remove Background'
            )}
          </Button>
        </div>

        {processedImageUrl && (
          <div className="space-y-4">
            <div className="border rounded-lg p-4 bg-gray-50">
              <p className="text-sm font-medium mb-2">Processed Logo:</p>
              <img 
                src={processedImageUrl} 
                alt="Processed logo" 
                className="max-w-full h-auto mx-auto"
                style={{ backgroundColor: 'white' }}
              />
            </div>
            
            <Button 
              onClick={downloadProcessedImage}
              variant="outline"
              className="w-full"
            >
              <Download className="w-4 h-4 mr-2" />
              Download Processed Logo
            </Button>
          </div>
        )}
      </div>
    </div>
  );
};

export default LogoProcessor;